import logo from "../../assets/images/logos/Logo_Artbanne_long.svg"
import logoWhite from "../../assets/images/logos/Logo_Artbanne_long_blanc.svg"

export default function LogoLong({ width, height, color = "dark" }) {
    return (
        <img src={color === "dark" ? logo : logoWhite} width={width} height={height} alt="Logo de L'Artbanne long" />
    )
};